module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", null, {
    openGalleryModal: _vm.openGalleryModal
  }), _vm._v(" "), _c('portal', {
    attrs: {
      "to": "modals"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.open) ? _c('modal', {
    staticClass: "modal--full  modal--full--dark-transparent  modal--higher",
    attrs: {
      "full": true
    },
    on: {
      "close": function($event) {
        _vm.closeGalleryModal()
      }
    }
  }, [_c('div', {
    staticClass: "wiggle",
    attrs: {
      "slot": "wiggle"
    },
    slot: "wiggle"
  }, [_c('svg', {
    staticClass: "white",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1132 175.83"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticStyle: {
      "fill-rule": "evenodd"
    },
    attrs: {
      "d": "M1132,0V175.83H0V79.23c18.71,1,21.35,22.34,42.05,20.89,21.9-1.53,20.23-25.48,42.13-27S107.77,95.52,129.68,94s20.23-25.47,42.13-27,23.59,22.41,45.5,20.88,20.23-25.48,42.13-27S283,83.24,304.93,81.71s20.23-25.47,42.13-27,23.58,22.41,45.49,20.88,20.23-25.48,42.14-27S458.27,71,480.18,69.44s20.23-25.48,42.14-27S545.9,64.84,567.81,63.3,588,37.83,610,36.29s23.58,22.41,45.49,20.88,20.23-25.48,42.14-27S721.16,52.56,743.07,51s20.23-25.48,42.14-27,23.59,22.41,45.5,20.87,20.23-25.47,42.13-27,23.59,22.41,45.5,20.88,20.23-25.48,42.14-27,23.58,22.4,45.49,20.87,20.24-25.48,42.15-27,23.59,22.41,45.5,20.87C1114.19,25,1114,3.86,1132,0Z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "carousel  js-carousel"
  }, [_vm._t("modal")], 2)]) : _vm._e()], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9e3b7f4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Gallery.vue
// module id = mUzW
// module chunks = 1